import { translate } from "../../Translations/translatorService";
import { STAGE_DATA_COMPLETED } from "../../Stages/StagesCase";
import { Badge } from "../../../types/Badge";
import { LitigationUnion } from "../../../types/LitigationUnion";

export const getLitigationCaseBadges = (product: LitigationUnion) => {
  let badges: Badge[] = [];

  if (product.stage && product.stage >= STAGE_DATA_COMPLETED) {
    badges.push({
      text: translate(product.productClassName + ".caseCategory.values." + product.caseCategory, "Noch nicht gesetzt"),
      isActive: true,
    });
  }

  if (product?.opposingPartyLegalEntity?.organization?.insolvencyStatus === "open") {
    badges.push({
      text: "Gegenseite im Insolvenzverfahren",
      isActive: true,
      variant: "error"
    });
  }

  return badges;
};
